module.exports = __webpack_public_path__ + "static/media/machine_group_red.dbd9dead.svg";